import MuiSkeleton from '@mui/material/Skeleton';
import { type SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';
import { useSkeletonStyles } from './skeleton.styles';
import { JSX } from 'react';

export type SkeletonProps = Pick<
  MuiSkeletonProps,
  'className' | 'animation' | 'variant' | 'width' | 'height' | 'children'
>;

export const Skeleton = ({
  animation = 'wave',
  variant = 'circular',
  width = 40,
  height = 40,
  ...rest
}: SkeletonProps): JSX.Element => {
  const styles = useSkeletonStyles();
  return (
    <MuiSkeleton
      css={styles.container}
      animation={animation}
      variant={variant}
      width={width}
      height={height}
      {...rest}
    />
  );
};
